Cartegraph.AjaxURL = require("System/AjaxURL");